import React from 'react';

import gsLogoWhite from '../assets/logos/general_de_seguros_logo.png';
import { LOGO_HREF } from '../constants/constants';

const NavbarContainer = () => {
  return (
    <div className="navbar">
      <div className="navbar-desktop">
        <a className="link-logo" href={LOGO_HREF}>
          <img alt="Logo General de Seguros" src={gsLogoWhite} />
        </a>
      </div>
    </div>
  );
};

export default NavbarContainer;
